// extracted by mini-css-extract-plugin
export default {"progressBarWrapper":"styles_progressBarWrapper__uPkdq","progressBar":"styles_progressBar__lQpEg","text":"styles_text__XClLE"};